import React from 'react';

const MFDRoom = () => {
  return (
    <div>MFDRoom</div>
  );
};

export default MFDRoom;